import React from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/img/logo.svg";
import { DiscordIcon, TelegramIcon, TwitterIcon } from "../SVGIcons";
import clsx from "clsx";

const HomeFooter = () => {
    return <div className="w-full border-t border-[#161616] pt-[60px] pb-[34px] px-[16px]">
        <div className={clsx(
            "w-full max-w-[1082px]  mx-auto flex flex-col gap-[32px] items-center",
            "md:items-start"
        )}>
            {/* Logo */}
            <Link to="/" className="flex items-center space-x-3 flex-shrink-0 group z-10">
                <img src={logo} alt="TaoFlow Logo" className="h-[42px] w-[42px]" />
                <span className="text-gray-900 dark:text-white font-bold text-xl group-hover:text-blue-700 dark:group-hover:text-gray-200 transition-colors duration-200">
                    TaoFlow
                </span>
            </Link>

            <div className={clsx(
                "text-[14px] font-normal text-white/50 text-center",
                "md:text-start"
            )}>
                Put your TAO to work. Earn yield. Trade with power.
            </div>

            <div className={clsx(
                "flex w-full justify-between items-center gap-[16px] flex-col",
                "md:flex-row md:items-start"
            )}>
                <div className="flex gap-[40px]">
                    <Link to="https://taoflow-1.gitbook.io/taoflow-docs" className="text-[16px] font-normal tracking-[-0.64px]">
                        Learn
                    </Link>
                    <Link to="/" className="text-[16px] font-normal tracking-[-0.64px]">
                        Build
                    </Link>
                    <Link to="/" className="text-[16px] font-normal tracking-[-0.64px]">
                        Explore
                    </Link>
                </div>

                <div className="flex gap-[12px]">
                    <Link to="/">
                        <button className="bg-[#28292E] rounded-full p-[10px]">
                            <TwitterIcon fillColor="white" />
                        </button>
                    </Link>
                    <Link to="https://discord.gg/Y6uC3v5ACZ">
                        <button className="bg-[#28292E] rounded-full p-[10px]">
                            <DiscordIcon fillColor="white" />
                        </button>
                    </Link>
                    {/* <Link to="/">
                        <button className="bg-[#28292E] rounded-full p-[10px]">
                            <TelegramIcon fillColor="white" />
                        </button>
                    </Link> */}
                </div>
            </div>

            <div className={clsx(
                "flex flex-col gap-[24px] items-center w-full",
                "md:flex-row md:justify-between md:pt-[30px] md:border-t md:border-[#161616]"
            )}>
                <div className="flex gap-[50px]">
                    <Link to="https://docs.google.com/document/d/1Ss40oOWDKFmCwnlhoOfMh0cdu8hWphK--enN7ZmFL9E/edit?usp=sharing" target="_blank" className="text-[14px] text-white/50">
                        Team of Use
                    </Link>
                    <Link to="https://docs.google.com/document/d/1pxcvNtxgxlLRE6Dd6e2MiyrzECX4drW8DT7mpgSjVis/edit?usp=sharing" target="_blank" className="text-[14px] text-white/50">
                        Privacy Policy
                    </Link>
                </div>
                <div className="text-[14px] text-white/50">
                    2025 Taoflow. All rights reserved.
                </div>
            </div>
        </div>
    </div>;
};

export default HomeFooter;
